<template>
  <div :class="['home-slider', 'flex', 'flex-column']">
    <div class="container" :style="screenWidth < 768 ? 'width: 100%': ''">
      <home-header style="height:40px;margin-top: 52px" v-if="screenWidth > 768"></home-header>

      <div class="legal-documents-title" style="margin: 200px auto; text-align: center;font-size: 40px;">
        Legal Documents
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from '@/components/header/header';

export default {
  name: 'slider',
  data(){
    return {
      screenWidth: window.screen.width,
    }
  },
  components: {
    HomeHeader
  }
}
</script>

<style scoped lang="scss">
.home-slider {
  height: 720px;
  background-size: cover;
  background-position: center center;
  background-color: black;
  @include bg-image('../../assets/image/home/slider1');
}

@media screen and (max-width: 768px) {
  .home-slider {
    height: 360px;
    .legal-documents-title{
      font-size: 24px !important;
      margin: 150px 50px !important;
      color: #FFF;
    }
  }
}
</style>
